<ms-antepost-common [vm]="vm" [crmPromotedOptionIdsMap]="crmPromotedOptionIdsMap"></ms-antepost-common>
